import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RouletteQuickDetails } from 'app/core/model/roulette-quick-details.model';
import { WebRouletteStatus } from 'app/core/model/web-roulette-status';
import { WebRouletteService } from 'app/public/services/web-roulette.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-my-roulettes',
  templateUrl: './my-roulettes.component.html',
  styleUrls: ['./my-roulettes.component.scss']
})
export class MyRoulettesComponent implements OnInit {

  roulettes$: Observable<RouletteQuickDetails[]> = new Observable<RouletteQuickDetails[]>();
  WebRouletteStatus = WebRouletteStatus;
  constructor(private webRouletteService: WebRouletteService, private localizationService: LocalizationService
    , private messageService: AdvMessageService, private router: Router, private commonService: CommonService) {
  }

  ngOnInit(): void {
    this.commonService.changeCurrentPageHeader(this.localizationService.Translate('MY_ROULETTES.TITLE'))
    this.loadData();

  }

  loadData() {
    this.roulettes$ = this.webRouletteService.getMyRoulettes().pipe(map(roulettes =>
      roulettes.sort((a, b) => new Date(b.CreatedDate).getTime() - new Date(a.CreatedDate).getTime())
        .map(roulette => {
          roulette.StartDate = roulette.StartDate ? new Date(roulette.StartDate) : null;
          roulette.EndDate = roulette.EndDate ? new Date(roulette.EndDate) : null;
          roulette.ExpireDescription = this.getExpireDaysDescription(roulette);
          return roulette;
        })));
  }
  getExpireDaysDescription(roulette: RouletteQuickDetails): string {
    let description;
    switch (roulette.Status) {
      case WebRouletteStatus.expired:
        description = this.localizationService.Translate('MY_ROULETTES.EXPIRE');
        break;
      case WebRouletteStatus.purchedNotLimitPackage:
        description = this.localizationService.Translate('MY_ROULETTES.NO_EXPIRE');
        break;
      case WebRouletteStatus.notPurched:
        description = '';
        break;
      case WebRouletteStatus.purchedButNotAvailable:
      case WebRouletteStatus.spinsLimit:
      case WebRouletteStatus.purched:
      case WebRouletteStatus.purchedFreePackage:
      case WebRouletteStatus.spinsLimitForFreePackage:
        if (!roulette.EndDate) {
          description = '';
          return;
        }
        let diffTime = roulette.EndDate.getTime() - (new Date()).getTime();
        diffTime /= 1000 * 60 * 60 * 24;//get diff in days
        diffTime = Math.ceil(diffTime);//round to up
        description = `${diffTime} ${this.localizationService.Translate('MY_ROULETTES.DAYS')}`;
        break;
    }
    return description;
  }
  getChangePackageText(roulette: RouletteQuickDetails): string {
    const descriptionTranslateKey = this.webRouletteService.getChangePackageText(roulette.Status, roulette.AutoRenewalPackage);
    return this.localizationService.Translate(descriptionTranslateKey);
  }
  isAllowedChangePackage(roulette: RouletteQuickDetails) {
    return roulette.Status !== WebRouletteStatus.purchedButNotAvailable && roulette.Status !== WebRouletteStatus.purchedNotLimitPackage;
  }

  changeToAvailable(roulette: RouletteQuickDetails) {

  }
  changePackage(roulette: RouletteQuickDetails) {
    this.router.navigate(['webplatform', 'roulette-subscribtion', roulette.Id]);
  }
  delete(roulette: RouletteQuickDetails) {
    this.messageService.showConfirmation(this.localizationService.Translate('MY_ROULETTES.DELETE_ROULETTE_CONFIRM_TITLE'),
      this.localizationService.Translate('MY_ROULETTES.DELETE_ROULETTE_CONFIRM_MSG', { rouletteName: roulette.Name }), () => {
        this.webRouletteService.deleteRoulette(roulette.Id).subscribe(res => {
          this.messageService.successMessage('MY_ROULETTES.DELETE_ROULETTE_SUCCESS', true);
          this.loadData();

        });
      });
  }
  viewRoulette(roulette: RouletteQuickDetails) {
    this.router.navigate(['webplatform', 'roulette', roulette.Id]);
  }


  ngOnDestroy() {
    this.commonService.clearCurrentPageHeader();
  }
}

